import React from 'react';
import './dashboard.scss';

export default function Dashboard(props) {
  return(
    <div data-testid="root-segment" className="Dashboard">Soon<sup>TM</sup></div>
  );
}
